import React from "react";
import classNames from "classnames";
import logo from "../../../assets/img/logo.svg";
import styles from "./Logo.css";

export default function Logo(props) {
  return (
    <svg
      viewBox={logo.viewBox}
      className={classNames(
        styles.root,
        props.isCompressed ? styles.compressed : {}
      )}
    >
      <title>Axios</title>
      <use xlinkHref={"#" + logo.id} />
    </svg>
  );
}
